export interface TransactionHistoryItem {
  id: number;
  userId: number;
  timestamp: string;
  transactionType: string;
  orderId?: string;
  orderDetails?: string;
  amount: number;
  description: string;
  previousCredits: number;
  newCredits: number;
  paymentId: number | null;
  payoutId: number | null;
}
export enum TransactionType {
  Credit = 1,
  Debit = 2,
  Reversal = 3,
  Earning = 4,
  Order = 5,
  Penalty = 6,
  Fee = 7,
  Promo = 8,
}
export interface MunicipalityStats {
municipality: string;
totalUsers: number;
newUsersThisMonth: number;
verifiedContractorsRatio: number;
totalOrders: number;
newOrdersThisMonth: number;
profits: number;
loss: number;
revenue: number;
}
export const TRANSACTION_TYPE_LABELS: Record<number, string> = {
  [TransactionType.Credit]: 'Credit',
  [TransactionType.Debit]: 'Debit',
  [TransactionType.Reversal]: 'Reversal',
  [TransactionType.Earning]: 'Earning',
  [TransactionType.Order]: 'Order',
  [TransactionType.Penalty]: 'Penalty',
  [TransactionType.Fee]: 'Fee',
  [TransactionType.Promo]: 'Promo',
};

export const TRANSACTION_TYPE_COLORS: Record<number, string> = {
  [TransactionType.Credit]: '#4caf50',     
  [TransactionType.Debit]: '#f44336',      
  [TransactionType.Reversal]: '#ff9800',  
  [TransactionType.Earning]: '#2196f3',   
  [TransactionType.Order]: '#9c27b0',     
  [TransactionType.Penalty]: '#f44336',   
  [TransactionType.Fee]: '#795548',       
  [TransactionType.Promo]: '#4caf50',     
};